interface IPromiseCacheOptions {
  maxEntries?: number;
}

export const createPromiseCache = <T>({ maxEntries }: IPromiseCacheOptions = {}) => {
  const cache = new Map<string, Promise<T>>();

  const trim = (): void => {
    if (!maxEntries) {
      return;
    }

    while (cache.size > maxEntries) {
      const oldestKey = cache.keys().next().value as string | undefined;

      if (oldestKey === undefined) {
        return;
      }

      cache.delete(oldestKey);
    }
  };

  return {
    getOrCreate(key: string, factory: () => Promise<T>): Promise<T> {
      const cached = cache.get(key);

      if (cached) {
        cache.delete(key);
        cache.set(key, cached);
        return cached;
      }

      const request = Promise.resolve()
        .then(factory)
        .catch(error => {
          cache.delete(key);
          throw error;
        });

      cache.set(key, request);
      trim();

      return request;
    },
  };
};
